webpackJsonp([14],{

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return firstEnterUrl; });
/* unused harmony export UA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isIOS; });
/* unused harmony export hitTab */
var firstEnterUrl = location.href;
var UA = window.navigator.userAgent.toLowerCase();
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
var hitTab = {
  user: false
};

/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_auth_get_open_id__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dlg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api__ = __webpack_require__(61);






var RESULT_OK = 0;
var RESULT_INVALID_CODE = 1;

/* harmony default export */ __webpack_exports__["a"] = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var code = to.query.code;
    var state = to.query.state;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_auth_get_open_id__["a" /* default */])(code, state, function (_ref) {
      var _ref$body = _ref.body,
          result = _ref$body.result,
          msg = _ref$body.msg,
          openid = _ref$body.openid;

      switch (result) {
        case RESULT_OK:
          localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["f" /* WECHAT_OPEN_ID */], openid);
          __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_api__["b" /* getLocalStorageItemOnce */])('leave_app_route') });
          break;
        case RESULT_INVALID_CODE:
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dlg__["a" /* alert */])(msg);
          break;
      }
    }, function (error) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dlg__["a" /* alert */])(error);
    });
  }
});

/***/ }),

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_auth_wx_login__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dlg__ = __webpack_require__(32);






var RESULT_OK = 0;
var RESULT_INVALID_CODE = 1;
var RESULT_NOT_BIND = 2;
var RESULT_INVALID_USER = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var code = to.query.code;
    var state = to.query.state;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_auth_wx_login__["a" /* default */])(code, state, function (_ref) {
      var _ref$body = _ref.body,
          result = _ref$body.result,
          msg = _ref$body.msg,
          token = _ref$body.token,
          account = _ref$body.account,
          openid = _ref$body.openid;

      switch (result) {
        case RESULT_OK:
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["c" /* OBTAIN_AUTHENTICATION */], token);
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["h" /* SET_ACCOUNT */], account);
          __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'Service' });
          break;
        case RESULT_INVALID_CODE:
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dlg__["a" /* alert */])(msg);
          break;
        case RESULT_NOT_BIND:
        case RESULT_INVALID_USER:
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dlg__["a" /* alert */])(msg, function () {
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'Login', params: { openid: openid } });
          });
      }
    }, function (error) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dlg__["a" /* alert */])(error);
    });
  }
});

/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_font_awesome_css_font_awesome_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_setup__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_setup__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_setup__ = __webpack_require__(84);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;



__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);



__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__router_setup__["a" /* default */])();



__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_setup__["a" /* default */])();



__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__plugins_setup__["a" /* default */])();

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createLogger;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_misc__ = __webpack_require__(138);




function createLogger() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === undefined ? true : _ref$collapsed,
      _ref$transformer = _ref.transformer,
      transformer = _ref$transformer === undefined ? function (state) {
    return state;
  } : _ref$transformer,
      _ref$mutationTransfor = _ref.mutationTransformer,
      mutationTransformer = _ref$mutationTransfor === undefined ? function (mut) {
    return mut;
  } : _ref$mutationTransfor;

  return function (store) {
    var prevState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_misc__["a" /* deepCopy */])(store.state);

    store.subscribe(function (mutation, state) {
      if (typeof console === 'undefined') {
        return;
      }
      var nextState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_misc__["a" /* deepCopy */])(state);
      var time = new Date();
      var formattedTime = ' @ ' + pad(time.getHours(), 2) + ':' + pad(time.getMinutes(), 2) + ':' + pad(time.getSeconds(), 2) + '.' + pad(time.getMilliseconds(), 3);
      var formattedMutation = mutationTransformer(mutation);
      var message = 'mutation ' + mutation.type + formattedTime;
      var startMessage = collapsed ? console.groupCollapsed : console.group;

      try {
        startMessage.call(console, message);
      } catch (e) {
        console.log(message);
      }

      console.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
      console.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
      console.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));

      try {
        console.groupEnd();
      } catch (e) {
        console.log('—— log end ——');
      }

      prevState = nextState;
    });
  };
}

function repeat(str, times) {
  return new Array(times + 1).join(str);
}

function pad(num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num;
}

/***/ }),

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_wx_token_getter__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_wx_token_getter_2__ = __webpack_require__(124);
var Login = function Login() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 251));
};



var auth = [{
  path: '/login',
  name: 'Login',
  component: Login,
  meta: { title: '登录', hideBack: true }
}, {
  path: '/get_wechat_token',
  component: __WEBPACK_IMPORTED_MODULE_0__components_wx_token_getter__["a" /* default */],
  meta: { auth: false }
}, {
  path: '/get_wechat_token_2',
  component: __WEBPACK_IMPORTED_MODULE_1__components_wx_token_getter_2__["a" /* default */],
  meta: { auth: false }
}];

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return intro; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_wx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(5);
var Intro = function Intro() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 245));
};
var IntroMain = function IntroMain() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 247));
};
var Program = function Program() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 248));
};
var ProgramShow = function ProgramShow() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 256));
};
var SignUp = function SignUp() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 250));
};
var ProgramUser = function ProgramUser() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 249));
};
var Hotel = function Hotel() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 246));
};





var intro = [{
  path: '/intro',
  component: Intro,
  meta: { auth: false },
  children: [{
    path: '',
    name: 'IntroMain',
    component: IntroMain,
    meta: { auth: false, title: '首页', hideBack: true }
  }, {
    path: '/programs',
    name: 'Program',
    component: Program,
    meta: { auth: false, title: '岗位培训列表', hideBack: true }
  }, {
    path: '/programs/:programId',
    name: 'ProgramShow',
    component: ProgramShow,
    meta: { auth: false, title: '培训详情', hideBack: true }
  }, {
    path: '/sign_up',
    name: 'SignUp',
    component: SignUp,
    meta: { auth: false, title: '报名', hideBack: true },
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* checkLocalStorage */])(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["f" /* WECHAT_OPEN_ID */]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_wx__["a" /* isWechatBrower */])()) {
        localStorage.setItem('leave_app_route', 'SignUp');
        window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_wx__["c" /* getAuthorizeUrl2 */])();
      } else {
        next();
      }
    }
  }, {
    path: '/program_user',
    name: 'ProgramUser',
    component: ProgramUser,
    meta: { auth: false, title: '学员信息', hideBack: true },
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* checkLocalStorage */])(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["f" /* WECHAT_OPEN_ID */]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_wx__["a" /* isWechatBrower */])()) {
        localStorage.setItem('leave_app_route', 'ProgramUser');
        window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_wx__["c" /* getAuthorizeUrl2 */])();
      } else {
        next();
      }
    }
  }, {
    path: '/hotels/:id',
    name: 'Hotel',
    component: Hotel,
    meta: { auth: false, title: '合作酒店', hideBack: true },
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* checkLocalStorage */])(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["f" /* WECHAT_OPEN_ID */]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_wx__["a" /* isWechatBrower */])()) {
        localStorage.setItem('leave_app_route', 'Hotel');
        window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_wx__["c" /* getAuthorizeUrl2 */])();
      } else {
        next();
      }
    }
  }]
}];

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return main; });
var Main = function Main() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 252));
};
var Home = function Home() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 253));
};
var Service = function Service() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 254));
};
var User = function User() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 255));
};
var ConsultShow = function ConsultShow() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 244));
};

var main = [{
  path: '/',
  component: Main,
  meta: { auth: true },
  children: [{
    path: '',
    name: 'Home',
    component: Home,
    meta: { auth: true, title: '首页', hideBack: true }
  }, {
    path: 'service',
    name: 'Service',
    component: Service,
    meta: { auth: true, title: '课程表', hideBack: true }
  }, {
    path: 'user',
    name: 'User',
    component: User,
    meta: { auth: true, title: '个人', hideBack: true }
  }, {
    path: 'consults/:consultId',
    name: 'ConsultShow',
    component: ConsultShow,
    meta: { auth: true, title: '新闻详情' }
  }]
}];

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["a"] = (function () {
  __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */].afterEach(function (route) {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["e" /* ROUTE_SWITCHING */], false);
  });
});

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_wx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["a"] = (function () {
  __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */].beforeEach(function (to, from, next) {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["e" /* ROUTE_SWITCHING */], true);
    if (to.matched.some(function (m) {
      return m.meta.auth;
    }) && !__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.authenticated) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_wx__["a" /* isWechatBrower */])()) {
        window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_wx__["b" /* getAuthorizeUrl */])();
      } else {
        next('/login');
      }
    } else {
      next();
    }
  });
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(5);




var _mutations;



var state = {
  id: -1,
  name: '',
  username: '',
  photo: '',
  is_male: '',
  birthday: '',
  type: -1,
  nation: '',
  native_place: '',
  political_status: '',
  graduate_school: '',
  major: '',
  edu_bg: '',
  degree: '',
  workplace: '',
  post: '',
  title: '',
  address: '',
  class: ''
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* SET_ACCOUNT */], function (state, account) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(account).forEach(function (key) {
    state[key] = account[key];
  });
  localStorage.setItem('mba_account', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(account));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* RETRIEVE_ACCOUNT */], function (state) {
  var accountStr = localStorage.getItem('mba_account');
  var hasAccount = !!accountStr;
  var account = JSON.parse(accountStr);

  if (hasAccount) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(account).forEach(function (key) {
      state[key] = account[key];
    });
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(5);


var _mutations;



var state = {
  isSwitching: false,
  mainListTabIndex: 1
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* ROUTE_SWITCHING */], function (state, isSwitching) {
  state.isSwitching = isSwitching;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* SET_MAIN_LIST_TAB_INDEX */], function (state, index) {
  state.mainListTabIndex = index;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(5);


var _mutations;



var state = {
  authenticated: false,
  header: ''
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* CHECK_AUTHENTICATION */], function (state) {
  state.authenticated = !!localStorage.getItem('id_token');
  if (state.authenticated) {
    state.header = 'Bearer ' + localStorage.getItem('id_token');
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* OBTAIN_AUTHENTICATION */], function (state, token) {
  state.authenticated = true;
  localStorage.setItem('id_token', token);
  state.header = 'Bearer ' + token;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* CLEAR_AUTHENTICATION */], function (state) {
  state.authenticated = false;
  localStorage.removeItem('id_token');
  state.header = '';
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__account__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(136);




/* harmony default export */ __webpack_exports__["a"] = ({
  app: __WEBPACK_IMPORTED_MODULE_0__app__["a" /* default */],
  account: __WEBPACK_IMPORTED_MODULE_1__account__["a" /* default */],
  auth: __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */]
});

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deepCopy; });
/* unused harmony export forEachValue */
/* unused harmony export isObject */
/* unused harmony export isPromise */
/* unused harmony export assert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);




function find(list, f) {
  return list.filter(f)[0];
}

function deepCopy(obj) {
  var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (obj === null || (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) !== 'object') {
    return obj;
  }

  var hit = find(cache, function (c) {
    return c.original === obj;
  });
  if (hit) {
    return hit.copy;
  }

  var copy = Array.isArray(obj) ? [] : {};

  cache.push({
    original: obj,
    copy: copy
  });

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy;
}

function forEachValue(obj, fn) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
    return fn(obj[key], key);
  });
}

function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) === 'object';
}

function isPromise(val) {
  return val && typeof val.then === 'function';
}

function assert(condition, msg) {
  if (!condition) throw new Error('[vuex] ' + msg);
}

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'alert',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_logger__ = __webpack_require__(127);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var debug = "testing" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  modules: __WEBPACK_IMPORTED_MODULE_2__modules__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */],
  strict: debug,
  plugins: debug ? [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__plugins_logger__["a" /* default */])()] : []
}));

/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__ = __webpack_require__(145);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toast',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__ = __webpack_require__(144);




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 220:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-alert"
  }, [_c('x-dialog', {
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition,
      "hide-on-blur": _vm.hideOnBlur,
      "mask-z-index": _vm.maskZIndex
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onHide
    }
  }, [_vm._v(_vm._s(_vm.buttonText || '确定'))])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-loading_toast vux-loading",
    class: !_vm.text ? 'vux-loading-no-text' : ''
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-toast",
    style: ({
      position: _vm.position
    })
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.text || '加载中')), _vm._t("default")], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-toast"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMask && _vm.show),
      expression: "isShowMask && show"
    }],
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.currentTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-toast",
    class: _vm.toastClass,
    style: ({
      width: _vm.width
    })
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'text'),
      expression: "type !== 'text'"
    }],
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style),
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style)
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-dialog",
    class: {
      'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-mask",
    style: (_vm.maskStyle),
    on: {
      "click": _vm.hide
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: _vm.dialogClass,
    style: (_vm.dialogStyle)
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(221)

var Component = __webpack_require__(21)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(236),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 241:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alert; });
/* unused harmony export toast */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);




function alert() {
  var _ref, _ref2;

  var n = arguments.length - 1;
  var onHide = typeof (arguments.length <= n ? undefined : arguments[n]) === 'function' ? (_ref = n--, arguments.length <= _ref ? undefined : arguments[_ref]) : null;
  var content = (_ref2 = n--, arguments.length <= _ref2 ? undefined : arguments[_ref2]);
  var title = n >= 0 ? arguments.length <= n ? undefined : arguments[n] : '';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$vux.alert.show({ title: title, content: content, onHide: onHide });
}

function _toast(type, text) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$vux.toast.show({ type: type, text: text });
}

var toast = {
  i: function i(text) {
    _toast('text', text);
  },
  w: function w(text) {
    _toast('warn', text);
  },
  s: function s(text) {
    _toast('success', text);
  },
  e: function e(text) {
    _toast('cancel', text);
  }
};

var loading = {
  show: function show(text) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$vux.loading.show({ text: text });
  },
  hide: function hide() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$vux.loading.hide();
  }
};

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isWechatBrower; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAuthorizeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAuthorizeUrl2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cfgJsSdk; });
/* unused harmony export cfgJsSdkSetUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routeTo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_global__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(8);






function isWechatBrower() {
  var microMessenger = navigator.userAgent.toLowerCase().match(/MicroMessenger/i);
  return microMessenger && microMessenger.toString() === 'micromessenger';
}

function getAuthorizeUrl() {
  var appId = "wx5aefcef0ed2a6173";
  var rUrl = window.encodeURIComponent("https://mba.tcd100.cn/get_wx_m_token");
  return 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&' + ('redirect_uri=' + rUrl + '&response_type=code&scope=snsapi_base&state=123#wechat_redirect');
}

function getAuthorizeUrl2() {
  var appId = "wx5aefcef0ed2a6173";
  var rUrl = window.encodeURIComponent("https://mba.tcd100.cn/get_wx_m_token_2");
  return 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&' + ('redirect_uri=' + rUrl + '&response_type=code&scope=snsapi_base&state=123#wechat_redirect');
}

function routeTo(route) {
  if (__WEBPACK_IMPORTED_MODULE_1__api_global__["a" /* isIOS */]) {
    var to = __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].resolve(route);
    location.href = to.href;
  } else {
    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(route);
  }
}

function cfgJsSdk(apiList, success, error) {
  var url = __WEBPACK_IMPORTED_MODULE_1__api_global__["a" /* isIOS */] ? __WEBPACK_IMPORTED_MODULE_1__api_global__["b" /* firstEnterUrl */] : location.href;
  cfgJsSdkSetUrl(apiList, url, success, error);
}

function cfgJsSdkSetUrl(apiList, url, success, error) {
  if (Array.isArray(apiList)) apiList = apiList.join();
  var wx = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].wechat;
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('/api/wx/js_sdk_config', { params: { url: url, apiList: apiList } }).then(function (_ref) {
    var config = _ref.body.config;

    var cfg = JSON.parse(config);
    wx.config(cfg);
    if (success) {
      wx.ready(function () {
        success();
      });
    }
    if (error) {
      wx.error(function (res) {
        error(res);
      });
    }
  });
}

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ROUTE_SWITCHING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_MAIN_LIST_TAB_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RETRIEVE_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECK_AUTHENTICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OBTAIN_AUTHENTICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR_AUTHENTICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return WECHAT_OPEN_ID; });
var ROUTE_SWITCHING = 'ROUTE_SWITCHING';

var SET_MAIN_LIST_TAB_INDEX = 'SET_MAIN_LIST_TAB_INDEX';

var SET_ACCOUNT = 'SET_ACCOUNT';
var RETRIEVE_ACCOUNT = 'RETRIEVE_ACCOUNT';

var CHECK_AUTHENTICATION = 'CHECK_AUTHENTICATION';

var OBTAIN_AUTHENTICATION = 'OBTAIN_AUTHENTICATION';

var CLEAR_AUTHENTICATION = 'CLEAR_AUTHENTICATION';

var WECHAT_OPEN_ID = 'WECHAT_OPEN_ID';

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLocalStorageItemOnce; });
/* unused harmony export getLocalStorage */
/* unused harmony export setLocalStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkLocalStorage; });


function getLocalStorageItemOnce(name) {
  var value = localStorage.getItem(name);
  localStorage.removeItem(name);
  return value;
}

function getLocalStorage(name) {
  return localStorage.getItem(name);
}

function setLocalStorage(name, value) {
  localStorage.setItem(name, value);
}

function checkLocalStorage(name) {
  return localStorage.getItem(name) !== null;
}

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mod_auth_route__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mod_main_route__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mod_intro_route__ = __webpack_require__(129);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/m/',
  routes: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__mod_auth_route__["a" /* auth */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__mod_main_route__["a" /* main */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__mod_intro_route__["a" /* intro */]), [{ path: '*', redirect: '/login' }])
}));

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dlg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_refresh__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_wx__ = __webpack_require__(33);










function isTokenExpired(body) {
  if (body instanceof ArrayBuffer) {
    var str = String.fromCharCode.apply(null, new Uint8Array(body));
    body = JSON.parse(str);
  }
  return body.message === 'Token has expired';
}

var pendingRequests = [];
var isRefreshing = false;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["a" /* CHECK_AUTHENTICATION */]);
  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["b" /* RETRIEVE_ACCOUNT */]);

  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.interceptors.push(function (request, next) {
    request.headers.set('Authorization', __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.auth.header);
    next(function (response) {
      if (response.status === 401 && isTokenExpired(response.body)) {
        if (isRefreshing) {
          pendingRequests.push(request);
          return;
        }

        isRefreshing = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__auth_refresh__["a" /* default */])().then(function (_ref) {
          var token = _ref.body;

          __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["c" /* OBTAIN_AUTHENTICATION */], token);var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pendingRequests), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var req = _step.value;

              req.headers.set('Authorization', __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.auth.header);
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http(req);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }).catch(function () {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pendingRequests), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var req = _step2.value;

              req.reject();
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          logout(true);
        }).finally(function () {
          isRefreshing = false;
          pendingRequests = [];
        });
      }
    });
  });
});

function logout() {
  var overdue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  if (overdue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dlg__["a" /* alert */])('用于通信的信标已过期,你必须重新登录!', function () {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["d" /* CLEAR_AUTHENTICATION */]);
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_wx__["a" /* isWechatBrower */])()) {
        window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_wx__["b" /* getAuthorizeUrl */])();
      } else {
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({ name: 'Login' });
      }
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({ name: 'Login' });
  }
}

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_alert_index_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_plugins_toast_index_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_plugins_loading_index_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_wechat_index_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_calendar__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_calendar_lib_v_calendar_min_css__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_calendar_lib_v_calendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_v_calendar_lib_v_calendar_min_css__);











/* harmony default export */ __webpack_exports__["a"] = (function () {
  __WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_alert_index_js__["a" /* default */]);
  __WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vux_src_plugins_toast_index_js__["a" /* default */]);
  __WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vux_src_plugins_loading_index_js__["a" /* default */]);
  __WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);
  __WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_v_calendar___default.a);
  __WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_wechat_index_js__["a" /* default */]);
});

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__before__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__after__ = __webpack_require__(131);



/* harmony default export */ __webpack_exports__["a"] = (function () {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__before__["a" /* default */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__after__["a" /* default */])();
});

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(220)

var Component = __webpack_require__(21)(
  /* script */
  null,
  /* template */
  __webpack_require__(235),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);


var API_GET_OPEN_ID = '/api/wx/get_wx_wechat_token_2';

/* harmony default export */ __webpack_exports__["a"] = (function (code, state) {
  var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var failed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_GET_OPEN_ID, { params: { code: code, state: state } }).then(function (resp) {
    if (success) success(resp);
  }).catch(function (error) {
    if (failed) failed(error);
  });
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);


var API_AUTH_REFRESH = '/api/wechat/auth/token/refresh';

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_AUTH_REFRESH);
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);


var API_AUTH_LOGIN = '/api/wx/get_wx_wechat_token';

/* harmony default export */ __webpack_exports__["a"] = (function (code, state) {
  var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var failed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_AUTH_LOGIN, { params: { code: code, state: state } }).then(function (resp) {
    if (success) success(resp);
  }).catch(function (error) {
    if (failed) failed(error);
  });
});

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(218)

var Component = __webpack_require__(21)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(233),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(217)

var Component = __webpack_require__(21)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(232),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(219)

var Component = __webpack_require__(21)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(234),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[126]);


// WEBPACK FOOTER //
// m/js/app.ad6864e1ce28458b5c0e.js